<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">课题管理&gt;</div>
      </div>

      <div class="body_content">
        <div class="body_top">
          <button type="button" class="btn btn-default btn_option" data-toggle="modal" data-target="#myModal" style="width: 140px">
            新增
          </button>
          <div class="searcharea">


            <input class="form-control" placeholder="名称"  v-model="searchParams.title"/>
            <button type="button" class="btn btn-default btn_option" @click="initDataList()">查询</button>
          </div>
        </div>
        <div class="classList_div">
          <table class="table table-striped table-bordered table_trainingManage" style="table-layout: fixed;">
            <thead>
            <tr>
              <th width="20%">项目名称</th>
              <th width="20%">科室/人员</th>
              <th width="30%">项目时间</th>
              <th width="10%">状态</th>
              <th width="15%">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(d, index) in dataList" :key="index">
              <td style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{d.title}}</td>
              <td>
                <p v-if="d.dept">科室：{{d.dept}}</p>
                <p v-if="d.personCharge">负责人：{{d.personCharge}}</p>
                <p v-if="d.personPart">参与人：{{d.personPart}}</p>
              </td>
              <td>
                <p v-if="!d.approvalDate">创建时间：{{d.createTime}}</p>
                <p v-if="d.approvalDate">立项时间：{{d.approvalDate}}</p>
                <p v-if="d.mediumStartDate">中期评审：{{d.mediumStartDate}} -- {{d.mediumEndDate}}</p>
                <p v-if="d.finalStartDate">结项评审：{{d.finalStartDate}} -- {{d.finalEndDate}}</p>
              </td>
              <td>
                {{statuses[d.status]}}
              </td>
              <td>
                <a href="#" data-toggle="modal" @click="edit(d)" v-if="d.status == '00'">修改</a>
                <a href="#" @click="deleteById(d.id)" v-if="d.status == '00'">删除</a>
                <a href="#" @click="updateStatus(d.id,'01','发布')" v-if="d.status == '00'">发布</a>
                <a href="#" @click="approval(d)" v-if="d.status == '10'">立项</a>
                <a href="#" @click="toExamine(d)" v-if="d.status == '20' || d.status == '30'">审核</a>
                <a href="#" @click="projectView(d,'查看')">查看</a>

<!--                <div class="edit_pic" data-toggle="modal"-->
<!--                     @click="edit(d)">-->
<!--                </div>-->
<!--                <div class="delete_pic" @click="deleteById(d.id)"></div>-->
              </td>
            </tr>
            </tbody>
          </table>
          <page-view v-bind="searchParams"></page-view>
          <!--新增或修改-->
          <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content modal-work-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel">
                    {{option_flag=="add"?'新增':'修改'}}
                  </h4>
                </div>
                <div class="modal-body modal_work_trainingManage">
                  <div>
                    <label>项目名称：</label>
                    <input type="text" class="form-control" v-validate="'required|maxL:100'" data-vv-scope="scope" data-vv-as="项目名称" name="title" placeholder="输入项目名称" v-model="data.title">
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('scope.title') }}</span>

                    <label>项目编号：</label>
                    <input type="text" class="form-control" v-validate="'maxL:30'" data-vv-scope="scope" data-vv-as="项目编号" name="code" placeholder="输入项目编号" v-model="data.code">
                    <span class="spanRed"></span>
                    <span class="validateTip">{{ errors.first('scope.code') }}</span>

                    <label>项目来源：</label>
                    <input type="text" class="form-control" v-validate="'maxL:100'" data-vv-scope="scope" data-vv-as="项目来源" name="source" placeholder="输入项目来源" v-model="data.source">
                    <span class="spanRed"></span>
                    <span class="validateTip">{{ errors.first('scope.source') }}</span>

                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" @click="saveData()">确定</button>
                  <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
                </div>
              </div>
            </div>
          </div>

          <!--立项-->
          <div class="modal fade" id="myApprovalModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content modal-work-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel">
                    立项
                  </h4>
                </div>
                <div class="modal-body modal_work_trainingManage">
                  <div>
                    <label style="width: 100px;">立项时间：</label>
                    <input style="width: 100px;" id="approvalDate" v-validate="'required|maxL:16'" data-vv-scope="approval" data-vv-as="立项时间" class="form-control datetimepicker"
                           size="16" type="text" name="approvalDate" readonly v-model="data.approvalDate"/>
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('approval.approvalDate') }}</span>
                    <br/>

                    <label style="width: 100px;">中期审核时间：</label>
                    <input style="width: 100px;" id="mediumStartDate" v-validate="'required|maxL:16'" data-vv-scope="approval" data-vv-as="中期审核开始时间" class="form-control datetimepicker"
                           size="16" type="text" name="mediumStartDate" readonly v-model="data.mediumStartDate"/>
                    <span class="spanRed">*</span>
                    ——
                    <input style="width: 100px;" id="mediumEndDate" v-validate="'required|maxL:16'" data-vv-scope="approval" data-vv-as="中期审核结束时间" class="form-control datetimepicker"
                           size="16" type="text" name="mediumEndDate" readonly v-model="data.mediumEndDate"/>
                    <span class="spanRed">*</span>
                    <br/>
                    <span class="validateTip">{{ errors.first('approval.mediumStartDate') }}</span>
                    <span class="validateTip">{{ errors.first('approval.mediumEndDate') }}</span>
                    <br/>

                    <label style="width: 100px;">结项审核时间：</label>
                    <input style="width: 100px;" id="finalStartDate" v-validate="'required|maxL:16'" data-vv-scope="approval" data-vv-as="结项审核开始时间" class="form-control datetimepicker"
                           size="16" type="text" name="finalStartDate" readonly v-model="data.finalStartDate"/>
                    <span class="spanRed">*</span>
                    ——
                    <input style="width: 100px;" id="finalEndDate" v-validate="'required|maxL:16'" data-vv-scope="approval" data-vv-as="结项审核结束时间" class="form-control datetimepicker"
                           size="16" type="text" name="finalEndDate" readonly v-model="data.finalEndDate"/>
                    <span class="spanRed">*</span>
                    <br/>
                    <span class="validateTip">{{ errors.first('approval.finalStartDate') }}</span>
                    <span class="validateTip">{{ errors.first('approval.finalEndDate') }}</span>
                    <br/>
<!--                    <div class="editVideoDiv" v-if="option_flag == 'edit'" style="margin-top: 5px;">-->
<!--                      <label>立项文件：</label>-->
<!--                      <p class="fileListP" v-for="(att, index) in edit_apply_file_data" :key="index">-->
<!--                        <a @click="openFileModal(att.filePath)">{{att.fileName}}</a>-->
<!--                        <span title="删除" class="glyphicon glyphicon-remove" @click="deleteAttachmentsFile('file', att.id)"></span>-->
<!--                      </p>-->
<!--                    </div>-->
                    <uploader :options="upload.approvalOptions" :file-status-text="upload.statusText"
                              class="uploader-example" ref="approvalFile" style="margin-top: 5px;">
                      <uploader-unsupport></uploader-unsupport>
                      <uploader-drop>
                        <p>拖拽立项文件至此处</p>
                        <uploader-btn :attrs="upload.attrs.file">上传立项文件</uploader-btn>
                      </uploader-drop>
                      <uploader-list>
                        <div
                          slot-scope="props"
                        >
                          <!--                          <div class="file-title">-->
                          <!--                            <p class="file-list-title">文件列表</p>-->
                          <!--                          </div>-->
                          <ul
                            class="file-list"
                            :class="'uploader-list-ul-show'"
                          >
                            <li v-for="file in props.fileList" :key="file.id">
                              <uploader-file
                                :class="'file_' + file.id"
                                ref="files"
                                :file="file"
                                :list="true"
                                style="text-align: left"
                              >
                                {{file.name}}<a v-if="!file.error" href="#" @click="fileRemoved(file,'approval')"
                                                style="float: right;margin-right: 5px;">删除</a>
                              </uploader-file>
                            </li>
                          </ul>
                        </div>
                      </uploader-list>
                    </uploader>

                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" @click="saveApproval()">确定</button>
                  <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
                </div>
              </div>
            </div>
          </div>

          <!--中期审核、结项审核-->
          <div class="modal fade" id="toExamineModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content modal-work-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel">
                    审核
                  </h4>
                </div>
                <div class="modal-body modal_work_trainingManage">
                  <div class="row">
                    <div class="col-md-6">
                      <label><input type="radio" name="option" value="1" @click="radioSelectChange(1)" v-model="radioSelect">审核通过</label>
                    </div>
                    <div class="col-md-6">
                      <label><input type="radio" name="option" value="0" @click="radioSelectChange(0)" v-model="radioSelect">审核不通过</label>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" @click="toExamineHandle(data.id,data.status)">确定</button>
                  <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
                </div>
              </div>
            </div>
          </div>

          <!--查看-->
          <div class="modal fade" id="projectView" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content modal-work-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel">
                    查看
                  </h4>
                </div>
                <div class="modal-body modal_work_trainingManage">
                  <div>
                    <label>项目基本信息</label>
                    <table class="table table-striped table-bordered table_trainingManage">
                      <tbody>
                      <tr style="text-align: left;">
                        <td>项目名称</td>
                        <td>{{data.title}}</td>
                        <td>项目编号</td>
                        <td>{{data.code}}</td>
                      </tr>
                      <tr style="text-align: left;">
                        <td>立项时间</td>
                        <td>{{data.approvalDate}}</td>
                        <td>状态</td>
                        <td>{{statuses[data.status]}}</td>
                      </tr>
                      <tr style="text-align: left;">
                        <td>中期审核时间</td>
                        <td>{{data.mediumStartDate}}--{{data.mediumEndDate}}</td>
                        <td>结项评审时间</td>
                        <td>{{data.finalStartDate}}--{{data.finalEndDate}}</td>
                      </tr>
                      <tr style="text-align: left;">
                        <td>项目来源</td>
                        <td>{{data.source}}</td>
                        <td>立项文件</td>
                        <td>
                          <template v-for="item in edit_approval_file_data">
                            <a @click="openFileModal(item.filePath)">查看</a>&nbsp;&nbsp;&nbsp;
                            <a @click="downloadFile(item.filePath)">下载</a><br/>
                          </template>
                        </td>
                      </tr>
                      <tr style="text-align: left;">
                        <td>项目人员</td>
                        <td>
                          <span  v-if="data.personCharge">负责人：{{data.personCharge}}</span><br/>
                          <span  v-if="data.personPart">参与人：{{data.personPart}}</span>
                        </td>
                        <td>负责科室</td>
                        <td>{{data.dept}}</td>
                      </tr>
                      </tbody>
                    </table>

                    <div style="margin-top: 10px;">
                      <label>项目申请</label>
                      <p><span v-if="edit_apply_file_data.length>0">申请书&nbsp;&nbsp;&nbsp;</span>
                        <template v-for="item in edit_apply_file_data">
                          <a @click="openFileModal(item.filePath)">查看</a>&nbsp;&nbsp;&nbsp;
                          <a @click="downloadFile(item.filePath)">下载</a>&nbsp;&nbsp;&nbsp;
                        </template>
                      </p>
                      <p><span v-if="edit_live_file_data.length>0">活&nbsp;&nbsp;&nbsp;页&nbsp;&nbsp;&nbsp;</span>
                        <template v-for="item in edit_live_file_data">
                          <a @click="openFileModal(item.filePath)">查看</a>&nbsp;&nbsp;&nbsp;
                          <a @click="downloadFile(item.filePath)">下载</a>&nbsp;&nbsp;&nbsp;
                        </template>
                      </p>
                    </div>

                    <div style="margin-top: 10px;">
                      <label>
                        项目中期考核
                        <span v-if="data.status == '21'" style="color: green;">考核通过</span>
                        <span v-if="data.status == '22'" style="color: red;">考核未通过</span>
                      </label>
                      <p><span v-if="edit_medium_file_data.length>0">中期研究报告&nbsp;&nbsp;&nbsp;</span>
                        <template v-for="item in edit_medium_file_data">
                          <a @click="openFileModal(item.filePath)">查看</a>&nbsp;&nbsp;&nbsp;
                          <a @click="downloadFile(item.filePath)">下载</a>&nbsp;&nbsp;&nbsp;
                        </template>
                      </p>
                    </div>

                    <div style="margin-top: 10px;">
                      <label>
                        项目结项考核
                        <!--                        <span v-if="data.status == '32'" style="color: green;">考核通过</span>-->
                        <!--                        <span v-if="data.status == '31'" style="color: red;">考核未通过</span>-->
                      </label>
                      <p><span v-if="edit_final_file_data.length>0">结项报告&nbsp;&nbsp;&nbsp;</span>
                        <template v-for="item in edit_final_file_data">
                          <a @click="openFileModal(item.filePath)">查看</a>&nbsp;&nbsp;&nbsp;
                          <a @click="downloadFile(item.filePath)">下载</a>
                        </template>
                      </p>
                    </div>

                    <div style="margin-top: 10px;">
                      <label>
                        查重报告
                      </label>
                      <p><span v-if="edit_repeat_file_data.length>0">查重报告&nbsp;&nbsp;&nbsp;</span>
                        <template v-for="item in edit_repeat_file_data">
                          <a @click="openFileModal(item.filePath)">查看</a>&nbsp;&nbsp;&nbsp;
                          <a @click="downloadFile(item.filePath)">下载</a>&nbsp;&nbsp;&nbsp;
                          <a v-if="data.status == '30'" @click="repeatFileRemoved(item)">删除</a>&nbsp;&nbsp;&nbsp;
                        </template>
                      </p>
                      <uploader v-if="data.status == '30' && edit_repeat_file_data.length<1" :options="upload.repeatOptions" :file-status-text="upload.statusText"
                                class="uploader-example" ref="repeatFile" style="margin-top: 5px;">
                        <uploader-unsupport></uploader-unsupport>
                        <uploader-drop>
                          <p>拖拽查重报告至此处</p>
                          <uploader-btn :attrs="upload.attrs.file">上传查重报告</uploader-btn>
                        </uploader-drop>
                        <uploader-list>
                          <div
                            slot-scope="props"
                          >
                            <!--                          <div class="file-title">-->
                            <!--                            <p class="file-list-title">文件列表</p>-->
                            <!--                          </div>-->

                            <ul
                              class="file-list"
                              :class="'uploader-list-ul-show'"
                            >
                              <li v-for="file in props.fileList" :key="file.id">
                                <uploader-file
                                  :class="'file_' + file.id"
                                  ref="files"
                                  :file="file"
                                  :list="true"
                                  style="text-align: left"
                                >
                                  {{file.name}}<a v-if="!file.error" href="#" @click="fileRemoved(file,'repeat')" style="float: right;margin-right: 5px;">删除</a>
                                </uploader-file>
                              </li>
                            </ul>
                          </div>
                        </uploader-list>
                      </uploader>
                    </div>

                  </div>
                </div>
                <div class="modal-footer">
<!--                  <button type="button" class="btn btn-default" @click="updateStatus(data.id,data.status,modalName)" v-if="modalName !='查看'">确定</button>-->
                  <button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
                </div>
              </div>
            </div>
          </div>

          <!--文档显示-->
          <div class="modal fade" id="myModal_showFile" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showFile" aria-hidden="true" data-backdrop='static'>
            <div class="modal-dialog modal-dialog-look">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                    &times;
                  </button>
                  <h4 class="modal-title" id="myModalLabel_showFile">
                    文档预览
                  </h4>
                </div>
                <div class="modal-body modal-body-look">
                  <iframe :src="fileSrc" width="100%" height="700px"></iframe>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from '../main';
  import {getContentSize} from './mainView';
  import pageView from './pageView';

  export default {
    name: "trainingManage",
    components:{pageView},
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,
        userId:this.$store.state.userId,
        resourcePath:  this.$store.state.serviceBase + "resources/",
        statuses:{
          "00": "未发布",
          "01": "已发布",
          "10": "已申请",
          "11": "已立项",
          "20": "中期审核",
          "21": "中期审核-通过",
          "22": "中期审核-未通过",
          "30": "结项审核",
          "31": "结项审核-未通过",
          "32": "已结项",
        },
        //今日日期
        timeDate: '',
        //培训人员集合
        dataList:[],

        option_flag: 'add',

        //培训人员对象
        data:{
          id:"",
          title:"",
          code:"",
          source:"",
          dept:"",
          personCharge:"",
          personPart:"",
          approvalDate:"",
          mediumStartDate:"",
          mediumEndDate:"",
          finalStartDate:"",
          finalEndDate:"",
          status:"",
          creator:"",
          userId:"",
          applicant:"",
          applicantId:"",
          createTime:""
        },
        searchParams: {
          title:'',
          all: 0,
          rows: 10,
          page:1
        },
        fileSrc: '',
        edit_approval_file_data: [],
        edit_apply_file_data: [],//申请书
        edit_live_file_data: [],//活页
        edit_medium_file_data: [],//中期研究报告
        edit_final_file_data: [],//结项材料
        edit_repeat_file_data: [],//查重报告
        //上传ID
        attachmentIds: '',
        //upload组件file的id与attachmentId对应关系集合[{fileId,fileType,attachmentId}]
        fileRelationshipArr: [],
        hrefExport:this.$store.state.serviceBase+"resources/",
        //上传
        upload: {
          approvalFile: null,
          repeatFile: null,
          approvalOptions: {
            target: this.$store.state.serviceBase + 'upload/chunkUpload.action',
            maxChunkRetries: 3,
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
              attachmentType: 'pro_approval'
            },
            simultaneousUploads: 1,
            testChunks: false,
            chunkSize: 1024*1024,
          },
          applyOptions: {
            target: this.$store.state.serviceBase + 'upload/chunkUpload.action',
            maxChunkRetries: 3,
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
              attachmentType: 'pro_apply'
            },
            simultaneousUploads: 1,
            testChunks: false,
            chunkSize: 1024*1024,
          },
          liveOptions: {
            target: this.$store.state.serviceBase + 'upload/chunkUpload.action',
            maxChunkRetries: 3,
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
              attachmentType: 'pro_live'
            },
            simultaneousUploads: 1,
            testChunks: false,
            chunkSize: 1024*1024,
          },
          mediumOptions: {
            target: this.$store.state.serviceBase + 'upload/chunkUpload.action',
            maxChunkRetries: 3,
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
              attachmentType: 'pro_medium'
            },
            simultaneousUploads: 1,
            testChunks: false,
            chunkSize: 1024*1024,
          },
          finalOptions: {
            target: this.$store.state.serviceBase + 'upload/chunkUpload.action',
            maxChunkRetries: 3,
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
              attachmentType: 'pro_final'
            },
            simultaneousUploads: 1,
            testChunks: false,
            chunkSize: 1024*1024,
          },
          repeatOptions: {
            target: this.$store.state.serviceBase + 'upload/chunkUpload.action',
            maxChunkRetries: 3,
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
              attachmentType: 'pro_repeat'
            },
            simultaneousUploads: 1,
            testChunks: false,
            chunkSize: 1024*1024,
          },
          attrs: {
            file: {
              accept: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/pdf'
            },
          },
          statusText: {
            success: '成功了',
            error: '出错了',
            uploading: '上传中',
            paused: '暂停中',
            waiting: '等待中',
          },
        },
        radioSelect: '1',
      }
    },


    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        this_.initDataList();//日期
        this_.dateDefault();
        //绑定加载关闭模态框时的事件
        this_.closeModal();
        this_.openModal();
        this_.searchParams.page = 1;
        this_.searchParams.pageCallback = this_.initDataList;

        //获得上传组件对象
        this_.upload.approvalFile = this_.$refs.approvalFile.uploader;

        this_.loadUpload()
      });
    },
    methods: {

      initDataList(pageParams){
        let this_ = this;
        if(pageParams)
          Object.assign(this_.searchParams, pageParams);

        let _searchParams = {};
        Object.assign(_searchParams, this_.searchParams);
        delete _searchParams.pageCallback;//提交前删除回调
        schoolAxios({
          method: 'get',
          url: 'research/projectPage',
          params: _searchParams
        }).then(function (resp) {
          if(resp.data.success){
            this_.dataList = resp.data.list;
            this_.searchParams.all = resp.data.totalPage;
            this_.searchParams.page = 1;
          }
        });
      },


      saveData(){
        let this_ = this;
        this_.$validator.validateAll('scope').then(result => {
          if (result) {
            let method = "";
            let url = "";
            if (this_.option_flag == "add") {
              method = "post";
              url = "research/add";
            } else {
              method = "put";
              url = "research/update";
            }
            let data = Object.assign({}, this_.data);
            data.createTime = ""
            delete data['attachments']
            console.log('---------------update:',this_.option_flag,data)
            schoolAxios({
              method: method,
              url: url,
              data: data
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                $("#myModal").modal("hide");
                this_.initDataList();
              } else {
                (data.message||"保存失败").showMessage();
              }
            });
          }
        });
      },

      saveApproval(){
        let this_ = this;
        this_.$validator.validateAll('approval').then(result => {
          if (result) {
            let data = Object.assign({}, this_.data, {attachmentIds: this_.attachmentIds,});
            data.createTime = ""
            delete data['attachments']
            console.log('------------------data:',data)
            schoolAxios({
              method: "put",
              url: "research/approval",
              data: data
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                $("#myModal").modal("hide");
                $("#myApprovalModal").modal("hide");
                setTimeout(function () {
                  this_.errors.clear('approval');
                });
                this_.initDataList();
              } else {
                (data.message||"保存失败").showMessage();
              }
            });
          }
        });
      },

      edit(d){
        let this_ = this;
        this_.data = d;
        this_.option_flag = "edit"
        $("#myModal").modal("show");
      },
      approval(d){
        let this_ = this;
        this_.data = d;
        // this_.option_flag = "edit"
        $("#myApprovalModal").modal("show");
        setTimeout(function () {
          this_.errors.clear('approval');
        });
      },
      toExamine(d){
        let this_ = this;
        this_.data = d;
        this_.radioSelect = '1'
        $("#toExamineModal").modal("show");
      },

      projectView(d,title){
        let this_ = this;
        this_.edit_approval_file_data.length= 0
        this_.edit_apply_file_data.length= 0
        this_.edit_live_file_data.length= 0
        this_.edit_medium_file_data.length= 0
        this_.edit_final_file_data.length= 0
        this_.edit_repeat_file_data.length= 0
        this_.data = d;
        this_.modalName = title
        // this_.option_flag = 'add';
        schoolAxios({
          method: 'get',
          url: 'research/findAttachment',
          params: {objId:d.id}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            console.log('-------------findAttachment:',data.list)
            data.list[0].attachments.forEach(i => {
              if(i.fileType == 'pro_approval'){
                this_.edit_approval_file_data.push(i)
              }
              if(i.fileType == 'pro_apply'){
                this_.edit_apply_file_data.push(i)
              }
              if(i.fileType == 'pro_live'){
                this_.edit_live_file_data.push(i)
              }
              if(i.fileType == 'pro_medium'){
                this_.edit_medium_file_data.push(i)
              }
              if(i.fileType == 'pro_final'){
                this_.edit_final_file_data.push(i)
              }
              if(i.fileType == 'pro_repeat'){
                this_.edit_repeat_file_data.push(i)
              }
            })
          }else{
            (data.message||"附件查询失败").showMessage();
          }
          $("#projectView").modal("show");
        })
      },

      /**
       * 删除培训人员
       */
      deleteById(id){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'research/delete',
            params: {id:id}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              // "删除成功".showMessage();
              this_.initDataList();
            }else{
              (data.message||"删除失败").showMessage();
            }
          })
        })
      },

      /**
       * 修改状态
       */
      updateStatus(id, newStatus, text){
        let this_ = this;
        let info = '确定' + text
        info.showConfirm(function () {
          schoolAxios({
            method: 'put',
            url: 'research/updateStatus',
            params: {id:id, status: newStatus}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              // "删除成功".showMessage();
              this_.initDataList();
            }else{
              (data.message||"操作失败").showMessage();
            }
          })
        })
      },

      toExamineHandle(id, oldStatus){
        let this_ = this;
        let newStatus = '22'
        if(this_.radioSelect == ''){
          "请选择审核结果".showMessage()
        }
        if(this_.radioSelect == '1'){
          //审核通过
          if(oldStatus == '20'){
            newStatus = '21'
          }
          if(oldStatus == '30'){
            newStatus = '32'
          }
        } else{
          //审核不通过
          if(oldStatus == '20'){
            newStatus = '22'
          }
          if(oldStatus == '30'){
            newStatus = '31'
          }
        }
        '确定提交审核结果'.showConfirm(function () {
          schoolAxios({
            method: 'put',
            url: 'research/updateStatus',
            params: {id:id, status: newStatus}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              // "删除成功".showMessage();
              this_.initDataList();
              $("#toExamineModal").modal("hide");
            }else{
              (data.message||"操作失败").showMessage();
            }
          })
        })
      },

      radioSelectChange(value){
        let this_ = this
        this_.radioSelect = value
      },

      /**
       * 打开文件模态框
       */
      openFileModal(filePath) {
        let this_ = this;
        let data = filePath.substring(0, 11);
        let fileId = filePath.substring(11, filePath.indexOf('.'));
        this_.fileSrc = this_.$store.state.serviceBase + "resources/" + data + fileId + "_file/" + fileId + ".html";
        console.log('-------------------fileSrc:',this_.fileSrc)
        $("#myModal_showFile").modal("show");
      },

      /**
       * 下载
       */
      downloadFile(filePath){
        let this_ = this;
        console.log('-------------------downloadFile:',this_.hrefExport+filePath)
        location.href=this_.hrefExport+filePath
      },

      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#myModal").on('hide.bs.modal', function () {
          this_.searchTeacherName = '';
          this_.queryInputDataArr = [];
          this_.data = {
            id:"",
            title:"",
            code:"",
            source:"",
            dept:"",
            personCharge:"",
            personPart:"",
            approvalDate:"",
            mediumStartDate:"",
            mediumEndDate:"",
            finalStartDate:"",
            finalEndDate:"",
            status:"",
            creator:"",
            userId:"",
            applicant:"",
            applicantId:"",
            createTime:""
          },

          this_.option_flag= 'add';
          setTimeout(function () {
            this_.errors.clear('scope');
          });

        });

        $("#myApprovalModal").on('hide.bs.modal', function () {
          this_.searchTeacherName = '';
          this_.queryInputDataArr = [];
          this_.data = {
            id:"",
            title:"",
            code:"",
            source:"",
            dept:"",
            personCharge:"",
            personPart:"",
            approvalDate:"",
            mediumStartDate:"",
            mediumEndDate:"",
            finalStartDate:"",
            finalEndDate:"",
            status:"",
            creator:"",
            userId:"",
            applicant:"",
            applicantId:"",
            createTime:""
          },
          this_.attachmentIds = "";
          this_.upload.approvalFile.cancel();
          if(this_.upload.repeatFile != null) {
            this_.upload.repeatFile.cancel();
          }
            // this_.option_flag= 'add';
          setTimeout(function () {
            this_.errors.clear('approval');
          });

        });

        $("#projectView").on('hide.bs.modal', function () {
          this_.searchTeacherName = '';
          this_.queryInputDataArr = [];
          this_.data = {
            id:"",
            title:"",
            code:"",
            source:"",
            dept:"",
            personCharge:"",
            personPart:"",
            approvalDate:"",
            mediumStartDate:"",
            mediumEndDate:"",
            finalStartDate:"",
            finalEndDate:"",
            status:"",
            creator:"",
            userId:"",
            applicant:"",
            applicantId:"",
            createTime:""
          },

            this_.attachmentIds = "";
          this_.upload.approvalFile.cancel();
          if(this_.upload.repeatFile != null) {
            this_.upload.repeatFile.cancel();
          }
          // this_.option_flag= 'add';
          setTimeout(function () {
            this_.errors.clear('scope');
          });

        });

      },
      openModal(){
        let this_ = this;
        $("#myModal").on('show.bs.modal', function () {
          setTimeout(function () {
            this_.errors.clear('scope');
          });
        });
        $("#projectView").on('show.bs.modal', function () {
          if(this_.data.status == '30' && this_.edit_repeat_file_data.length < 1) {
            this_.upload.repeatFile = this_.$refs.repeatFile.uploader;
            this_.loadUploadRepeat()
          }
        });
      },
      /**
       * 初始化日期选这框
       */
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('.datetimepicker').datetimepicker({
          minView: "month",
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          startView: 2,
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let id = ev.delegateTarget.id;
          if(id == "approvalDate"){
            let value = $("#approvalDate").val();
            this_.data.approvalDate = value;
          }
          if(id == "mediumStartDate"){
            let value = $("#mediumStartDate").val();
            this_.data.mediumStartDate = value;
          }
          if(id == "mediumEndDate"){
            let value = $("#mediumEndDate").val();
            this_.data.mediumEndDate = value;
          }
          if(id == "finalStartDate"){
            let value = $("#finalStartDate").val();
            this_.data.finalStartDate = value;
          }
          if(id == "finalEndDate"){
            let value = $("#finalEndDate").val();
            this_.data.finalEndDate = value;
          }
          ev.preventDefault();
          ev.stopPropagation();
        });
      },

      /**
       * 拼接附件ID
       */
      splitAttachmentIds(attachmentIds){
        let this_ = this;
        if(this_.attachmentIds != ""){
          this_.attachmentIds += ",";
        }
        this_.attachmentIds += attachmentIds;
      },

      deleteAttachmentsFile(deleteFileType, id){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'upload/delete.action',
            params: {
              uploadAttachmentId: id
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              "删除成功".showMessage();
              if(deleteFileType == "approval"){
                //立项文件
                let index = -1;
                for(let i=0; i<this_.edit_approval_file_data.length; i++){
                  if(this_.edit_approval_file_data[i].id == id){
                    index = i;
                  }
                }
                if(index >= 0){
                  this_.edit_approval_file_data.splice(index, 1);
                }
              }else if(deleteFileType == "image"){
                //活页
                // let index = -1;
                // for(let i=0; i<this_.edit_live_file_data.length; i++){
                //   if(this_.edit_live_file_data[i].id == id){
                //     index = i;
                //   }
                // }
                // if(index >= 0){
                //   this_.edit_current_file_data.splice(index, 1);
                // }
              }else {

              }
            }else{
              "删除失败".showMessage();
            }
          })
        })
      },

      /**
       * 上传加载
       */
      loadUpload(){
        let this_ = this;
        /**
         * 文件上传验证处理
         */
        this_.upload.approvalFile.on('fileAdded', function (file, event) {
          if(this_.upload.attrs.file.accept.indexOf(file.fileType)==-1){
            (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
            return false;
          }
        });
        this_.upload.approvalFile.on('fileSuccess', function (rootFile, file, message, chunk) {
          if(message){
            let message_ = JSON.parse(message);
            if(this_.attachmentIds != ""){
              this_.attachmentIds += ",";
            }
            this_.attachmentIds += message_.message;
            this_.fileRelationshipArr.push({fileId:file.id,fileType:'approval',attachmentId:message_.message})
          }
        });
        this_.upload.approvalFile.on('fileComplete', function (rootFile) {
          console.info(rootFile);
        });
        this_.upload.approvalFile.on('fileError', function (rootFile, file, message) {
          (file.name+"上传失败").showMessage();
        });

      },
      loadUploadRepeat(){
        let this_ = this;
        this_.upload.repeatFile.on('fileAdded', function (file, event) {
          if(this_.upload.attrs.file.accept.indexOf(file.fileType)==-1){
            (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
            return false;
          }
        });
        this_.upload.repeatFile.on('fileSuccess', function (rootFile, file, message, chunk) {
          if(message){
            let message_ = JSON.parse(message);
            if(this_.attachmentIds != ""){
              this_.attachmentIds += ",";
            }
            this_.attachmentIds += message_.message;
            this_.fileRelationshipArr.push({fileId:file.id,fileType:'repeat',attachmentId:message_.message})
            //附件objId关联课题ID
            console.log('-----------------附件objId关联课题ID:',message_.message)
            schoolAxios({
              method: "put",
              url: "research/relationRepeatFile",
              data: {id:this_.data.id,attachmentIds:message_.message}
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                console.log('关联成功')
              } else {
                (data.message||"保存失败").showMessage();
              }
            });
          }
        });
        this_.upload.repeatFile.on('fileComplete', function (rootFile) {
          console.info(rootFile);
        });
        this_.upload.repeatFile.on('fileError', function (rootFile, file, message) {
          (file.name+"上传失败").showMessage();
        });
      },
      fileRemoved(file,type) {
        let this_ = this;
        if('approval' == type){
          this_.upload.approvalFile.removeFile(file)
        }
        if('repeat' == type){
          this_.upload.repeatFile.removeFile(file)
        }
        let arr = []
        let id = ''
        this_.fileRelationshipArr.forEach(i=>{
          if(i.fileType == type && i.fileId == file.id){
            //清理attachmentIds
            id = i.attachmentId
            this_.attachmentIds = this_.attachmentIds.replace(i.attachmentId,'_')
              .replace(',_','').replace('_,','').replace('_','')
          } else{
            arr.push(i)
          }
        })
        this_.fileRelationshipArr.length = 0
        this_.fileRelationshipArr = arr
        if(id != ''){
          schoolAxios({
            method: 'delete',
            url: 'upload/delete.action',
            params: {
              uploadAttachmentId: id
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              // "删除成功".showMessage();

            }else{
              // "删除失败".showMessage();
            }
          })
        }
      },
      repeatFileRemoved(file) {
        let this_ = this;
          this_.edit_repeat_file_data.splice(file)
          schoolAxios({
            method: 'delete',
            url: 'upload/delete.action',
            params: {
              uploadAttachmentId: file.id
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              // "删除成功".showMessage();

            }else{
              // "删除失败".showMessage();
            }
          })

      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .body_top {
    margin: 20px 0;
  }
  .searcharea{
    width: 80%;
    float: right;
    text-align: right;
  }
  .searcharea .form-control{
    display: inline-block;
    width: 160px;
  }
  .searcharea button{
    width: 60px;
  }
  .table_trainingManage {
    margin: 20px 0 0 0;
  }
  table tr{
    text-align: center;
  }
  table th {
    background: #cccccc;
    text-align: center;
  }
  .table-striped {
    /*background-color: #D7D7D7;*/
  }
  .edit_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/trainingManage/edit_mouseOver.png");
    background-size: 100% 100%;
    float: left;
    margin: 0 25px 0 25px;
  }
  .delete_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/trainingManage/delete_mouseOver.png");
    background-size: 100% 100%;
    float: left;
  }
  .modelInput{
    height: 34px;
    width: 90%;
    margin-top: 2%;
    margin-left: 5%;
  }

  #time_div {
    position: absolute;
    left: 26px;
    width: 84%;
    border: 1px grey solid;
    background-color: white;
    display: none;
    z-index: 1;
  }
  #time_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  #time_div option:hover {
    background-color: grey;
  }
  .modal-body .form-control{
    display: inline-block;
    width: 80%;
  }
</style>



// WEBPACK FOOTER //
// src/components/research.vue